import React from "react";
import { FormControl } from "react-bootstrap";
import Layout from "components/Layout";
import SubmitButton from "components/SubmitButton";
import { functionsService } from "services";
import { errorFormating } from "utils/utils";
import { withTranslation } from "react-i18next";

class FunctionsImports extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			submitted: false,
			errors: {},
			importErrors: [],
			importMessages: [],
			selectedFile: null,
			fileInputKey: 0,
		};
	}

	resetFileInput = () => {
		this.setState((prev) => ({
			selectedFile: null,
			fileInputKey: prev.fileInputKey + 1,
		}));
	};

	async handleDownloadTemplate() {
		const response = await functionsService.downloadImportTemplate();

		var url = window.URL.createObjectURL(response);
		var a = document.createElement("a");
		document.body.appendChild(a);
		a.href = url;
		a.download = "import_template.xlsx";
		a.click();
	}

	handleImport = async (event) => {
		event.preventDefault();
		this.setState({ isLoading: true });

		if (this.state.selectedFile) {
			try {
				var formData = new FormData();
				formData.append("filename", this.state.selectedFile);
				const response = await functionsService.prepareImport(formData);

				if (response.ok && !response.has_errors) {
					this.setState(
						{
							isLoading: false,
							errors: {},
							importMessages: [],
							importErrors: [],
						},
						() => {
							if (response.token) {
								this.runImport(response.token);
							}
						}
					);
				} else if (!response.ok) {
					this.setState({
						isLoading: false,
						submitted: true,
						importMessages: [],
						importErrors: [],
						errors: {
							message: this.props.t("functions.import.errorGeneric"),
						},
					});
				} else {
					var importErrors = [];
					if (response.rows.length > 0)
						importErrors = importErrors.concat(response.rows);
					if (response.header.errors !== undefined && response.header.errors.length > 0)
						importErrors = importErrors.concat(response.header.errors);

					this.setState({
						isLoading: false,
						submitted: true,
						errors: response.rows.length > 0 ? {} : response.errors[0],
						importMessages: [],
						importErrors,
					});
				}
			} catch (error) {
				console.error("Error during import:", error);
				this.resetFileInput();
				this.setState({
					isLoading: false,
					submitted: true,
					importMessages: [],
					importErrors: [],
					errors: {
						message: this.props.t("functions.import.errorGeneric"),
					},
				});
			}
		} else {
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t("functions.import.errorNoFile"),
				},
			});
		}
	};

	runImport = async (token) => {
		this.setState({ isLoading: true });

		try {
			const response = await functionsService.runImport(token);

			if (response.ok) {
				this.setState((prev) => ({
					isLoading: false,
					selectedFile: null,
					fileInputKey: prev.fileInputKey + 1,
					errors: {},
					importErrors:
						response.has_errors && response.rows.length > 0 ? response.rows : [],
					importMessages: response.rows.length > 0 ? response.rows : [],
				}));
			} else {
				this.setState({
					isLoading: false,
					submitted: true,
					errors: errorFormating(response),
				});
			}
		} catch (error) {
			console.error("Error during import:", error);
			this.resetFileInput();
			this.setState({
				isLoading: false,
				submitted: true,
				importMessages: [],
				importErrors: [],
				errors: {
					message: this.props.t("functions.import.errorGeneric"),
				},
			});
		}
	};

	getImportErrors = (rows) =>
		rows.map((row, i) => {
			const noRowErrors = (row.errors === undefined || row.errors.length === 0);
			if (noRowErrors && row.message === undefined) {
				return (<li key={i} className="hidden"></li>);
			} else if (noRowErrors && row.message !== undefined) {
				return (
					<li key={i}>
						<span className="import-count">{row.message}</span>
					</li>
				);
			}
			return (
				<li key={i}>
					<span className="import-count">{this.props.t("functions.import.row")} {row.row}</span>
					<ul className="import-details">
						{this.getImportErrorsDetails(row.errors)}
					</ul>
				</li>
			);
		});

	getImportErrorsDetails = (errors) =>
		errors.map((error, i) => {
			return <li key={i}>{error.message}</li>;
		});

	getImportMessages = (rows) =>
		rows.map((row, i) => {
			return (
				<li key={i}>
					<span className="import-count">{this.props.t("functions.import.row")} {row.row}</span>
					<span className="import-text">{row.message}</span>
				</li>
			);
		});

	handleChange = (event) => {
		this.setState({
			selectedFile: event.target.files[0],
		});
	};

	getContent = () => {
		const { t } = this.props;
		return (
			<form key={this.state.fileInputKey} onSubmit={this.handleImport}>
				<ol className="steps">
					<li className="step-download">
						{t("functions.import.downloadStep")}{" "}
						<span
							className="link"
							onClick={() => this.handleDownloadTemplate()}
						>
							{t("functions.import.downloadTemplate")}
						</span>{" "}
						{t("functions.import.downloadSuffix")}
					</li>
					<li className="step-upload">
						<div className="step-upload-content">
							{t("functions.import.uploadStep")}
							<FormControl
								type="file"
								onChange={this.handleChange}
								className="form-control"
							/>
						</div>
					</li>
				</ol>
				<SubmitButton
					type="submit"
					isLoading={this.state.isLoading}
					text={t("functions.import.submit")}
					loadingText={t("functions.import.submitting")}
				/>
			</form>
		);
	};

	render() {
		const { t } = this.props;
		const { importErrors, importMessages, errors } = this.state;

		return (
			<Layout className="page-imports" context="employees">
				<div className="heading">
					<div className="heading-left">
						<h1 className="title">{t("functions.import.title")}</h1>
					</div>
				</div>

				{this.getContent()}

				{errors.message && <p className="error-message">{errors.message}</p>}

				{importErrors.length > 0 && (
					<div className="import-list import-errors">
						<p className="import-list-text">
							{t("functions.import.errorsFound")}
						</p>
						<ul className="import-rows">
							{this.getImportErrors(importErrors)}
						</ul>
					</div>
				)}

				{importMessages.length > 0 && (
					<div className="import-list import-messages">
						<p className="import-list-text">{t("functions.import.importResult")}</p>
						<ul className="import-rows">
							{this.getImportMessages(importMessages)}
						</ul>
					</div>
				)}
			</Layout>
		);
	}
}

export default withTranslation()(FunctionsImports);
